export const tryParseAttributeValue = (texto) => {
    try {
      const obj = JSON.parse(texto);
  
      const value = Object.keys(obj);
      const isValid = typeof obj === 'object' &&
        obj !== null && value.length === 2 &&
        value.includes('label') && value.includes('value');
  
      return isValid ? obj : texto;
    } catch (e) {
      return texto;
    }
  }
  